import { render, staticRenderFns } from "./CulturalEventsPage.vue?vue&type=template&id=e4fd711c&scoped=true"
import script from "./CulturalEventsPage.vue?vue&type=script&lang=js"
export * from "./CulturalEventsPage.vue?vue&type=script&lang=js"
import style0 from "./CulturalEventsPage.vue?vue&type=style&index=0&id=e4fd711c&prod&lang=css"
import style1 from "./CulturalEventsPage.vue?vue&type=style&index=1&id=e4fd711c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fd711c",
  null
  
)

export default component.exports